import React, { useState, useEffect } from 'react';
import { FaLaptopMedical, FaFileMedical, FaHeadset } from 'react-icons/fa';

const services = [
    {
        icon: FaLaptopMedical,
        title: "Telemedicine",
        description: "Connect with our healthcare professionals through secure video consultations from the comfort of your home, saving time and travel."
    },
    {
        icon: FaFileMedical,
        title: "Health Record Management",
        description: "Access and manage your complete medical history securely through our encrypted platform, ensuring your data is always available when needed."
    },
    {
        icon: FaHeadset,
        title: "24/7 Support",
        description: "Our dedicated healthcare team is available around the clock to address your concerns, answer questions, and provide guidance whenever you need it."
    },
];

const Services = () => {
    const [loading, setLoading] = useState(true);
    const [displayedServices, setDisplayedServices] = useState([]);

    // Simulate loading of services
    useEffect(() => {
        const timer = setTimeout(() => {
            setDisplayedServices(services);
            setLoading(false);
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    return (
        <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
            <div className="container mx-auto px-4 max-w-7xl">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600">Our Services</span>
                    </h2>
                    <div className="w-24 h-1 mx-auto bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full mb-6"></div>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Comprehensive healthcare solutions designed with your needs in mind
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
                    {loading ? (
                        // Skeleton loaders while content is loading
                        Array(3).fill(0).map((_, index) => (
                            <div key={index} className="bg-white p-8 rounded-xl shadow-md animate-pulse">
                                <div className="w-16 h-16 bg-gray-200 rounded-full mx-auto"></div>
                                <div className="h-6 bg-gray-200 rounded w-1/2 mx-auto mt-6"></div>
                                <div className="h-4 bg-gray-100 rounded w-3/4 mx-auto mt-4"></div>
                                <div className="h-4 bg-gray-100 rounded w-2/3 mx-auto mt-2"></div>
                            </div>
                        ))
                    ) : (
                        displayedServices.map((service, index) => (
                            <div
                                key={index}
                                className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 relative overflow-hidden group"
                            >
                                <div className="absolute top-0 right-0 w-32 h-32 bg-blue-50 rounded-full -mr-16 -mt-16 z-0"></div>
                                <div className="relative z-10">
                                    <div className="mb-6 relative inline-block">
                                        <div className="absolute inset-0 bg-blue-100 rounded-full w-20 h-20 opacity-70 group-hover:scale-110 transition-transform duration-300"></div>
                                        <service.icon className="text-blue-600 text-5xl relative z-10" />
                                    </div>

                                    <h3 className="text-2xl font-bold text-gray-800 mb-3">{service.title}</h3>
                                    <p className="text-gray-600 leading-relaxed">{service.description}</p>

                                    <div className="mt-6 inline-block">
                                        <button className="flex items-center text-blue-600 font-medium group-hover:text-blue-700 transition-colors">
                                            <span>Learn more</span>
                                            <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                <div className="mt-16 text-center">
                    <a
                        href="#contact"
                        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        Get Started Today
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Services;
